import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppBar, Toolbar, Typography, IconButton, Drawer, List, ListItemText, ListItemButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useLimits } from '../utils/limitsContext';

const Navigation: React.FC = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const navigate = useNavigate();
  const { refresh } = useLimits();

  const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (event.type === 'keydown' && ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')) {
      return;
    }
    setDrawerOpen(open);
  };

  const close = () => setDrawerOpen(false);

  const handleClearData = () => {
    localStorage.clear();
    navigate('/');
    close();
  };

  const handleRefreshLimits = async () => {
    await refresh();
    close();
  };

  const menuItems = [
    { text: 'Calculation', onClick: () => { navigate('/'); close(); } },
    { text: 'History', onClick: () => { navigate('/history'); close(); } },
    { text: 'Refresh Limits', onClick: handleRefreshLimits },
    { text: 'Clear Data', onClick: handleClearData },
  ];

  return (
    <>
      <AppBar position="static">
        <Toolbar>
          <IconButton edge="start" color="inherit" aria-label="menu" onClick={toggleDrawer(true)}>
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Salary Calculator
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
        <List>
          {menuItems.map((item, index) => (
            <ListItemButton key={index} onClick={item.onClick}>
              <ListItemText primary={item.text} />
            </ListItemButton>
          ))}
        </List>
      </Drawer>
    </>
  );
};

export default Navigation;